<template>
    <div id="clientNiceAndNeat">
        <div id="PositionData">
            <div class="e-card mt-2">
                <div class="form-row col-lg-12">
                    <div class="col-sm-3">
                        <div class="col-sm-12 m-2">
                            <ejs-dropdownlist id="dplReportingView" name="dplReportingView" ref="reportingView" :dataSource='reportingView' :fields="{text: 'name', value: 'id' }" :select='onReportViewSelect' placeholder="Reporting View" floatLabelType='Auto'></ejs-dropdownlist>
                        </div>
                        <div class="col-sm-12 m-2">
                            <ejs-dropdownlist ref='dplPeriod' id="period" name="period" :change="onPeriodChange" :dataSource='periods' :fields="{text: 'name', value: 'id' }" placeholder="Period" floatLabelType='Auto'></ejs-dropdownlist>

                        </div>
                        <div class="col-sm-12 m-2 df">
                            <ejs-dropdownlist ref='dplCurrency' id="currency" name="currency" v-model="data.currencyId" :change="onCurrencyChange" :dataSource='currencies' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :showClearButton='true'></ejs-dropdownlist>
                            <ejs-checkbox cssClass="postionCheck check-d" ref='dmCheck' :checked="isChecked"
                               @change="updateChecked" label='Default Mechanism' id="clientPositionSummaryCheck" name="checkName" floatLabelType='Auto'></ejs-checkbox>
                        </div>
                    </div>
                    <div class="col-sm-4  justify-content-end ">
                        <label style="color: #f78764;">Data shown is from yesterday EOD, you can generate latest hitting refresh data button</label>
                    </div>
                    <div class="col-sm-2">
                        <label id="lbltimeUpdated" name="lbltimeUpdated" ref="lbltimeUpdated">Time Updated:{{timeUpdated}}</label>
                    </div>
                    <div class="col-sm-3  justify-content-end ">
                        <ejs-button cssClass="e-primary" v-on:click.native='refreshData'>Refresh Data</ejs-button>
                        <ejs-button cssClass="e-primary e-primary-group" ref='btnM2mReport' v-on:click.native='downloadM2M'>M2M Report</ejs-button>
                        <ejs-button cssClass="e-primary e-primary-group" ref="btnPositionSummary" v-on:click.native='download'>Position Summary</ejs-button>
                    </div>

                </div>

                <div v-if="electricityCalPosition && electricityCalPosition.length > 0">
                    <div class="row">
                        <div class="col m-3">
                            <div class="e-control e-grid e-responsive e-default" style="background-color: #d9843b; color: #001c55; ">
                                <CIcon name="cil-bolt"  style="color: #001c55; margin-left: 0.5%;" /> Power
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col m-3">
                            <ejs-grid ref='electricityGrid' :dataBound='dataBoundPower'
                                      :dataSource='electricityCalPosition'
                                      :allowPaging='false'
                                      :allowResizing='true'
                                      :allowReordering='false'
                                      :actionBegin='actionBegin' :actionComplete='actionComplete'
                                      :allowSorting='false' :allowTextWrap='true' :textWrapSettings='wrapSettings'
                                      :autoFit='true' :queryCellInfo='customiseCell'>
                                <e-columns>
                                    <e-column field='countryName' headerText='Country' width=120 textAlign="Center"></e-column>
                                    <e-column field='yearName' headerText='Year' width=120 textAlign="Center" :visible="false"></e-column>
                                    <e-column field='calendarYear' headerText='Year' width=120 textAlign="Center"></e-column>
                                    <e-column field='totalContractedVolume' textAlign="Center" headerText='Total Contracted Volume' width="20" format="n2"></e-column>
                                    <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                                    <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                                    <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                                    <e-column field='Reference' :columns='referenceColumns' textAlign="Center"></e-column>
                                    <e-column field='Variance to Reference' :columns='varianceColumns' textAlign="Center"></e-column>
                                    <e-column field='YoY' :columns='YoYColumns' textAlign="Center"></e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>
                <div v-if="gasCalPosition && gasCalPosition.length > 0">
                    <div class="row">
                        <div class="col m-3">
                            <div class="e-control e-grid e-responsive e-default" style="background-color: #7FB7BE; color: #001c55;">
                                <CIcon name="cil-fire" style="color: #001c55; margin-left: 0.5%;" /> Gas
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col m-3">
                            <ejs-grid ref='gasGrid' :dataBound='dataBoundGas'
                                      :dataSource='gasCalPosition'
                                      :allowPaging='false'
                                      :allowResizing='true'
                                      :allowReordering='false'
                                      :actionBegin='actionBegin' :actionComplete='actionComplete'
                                      :allowSorting='false' :allowTextWrap='true' :textWrapSettings='wrapSettings'
                                      :autoFit='true' :queryCellInfo='customiseCell'>
                                <e-columns>
                                    <e-column field='countryName' headerText='Country' textAlign="Center" width=120></e-column>
                                    <e-column field='yearName' headerText='Year' textAlign="Center" width=120 :visible="false"></e-column>
                                    <e-column field='calendarYear' headerText='Year' width=120 textAlign="Center"></e-column>
                                    <e-column field='totalContractedVolume' textAlign="Center" headerText='Total Contracted Volume' :width="20" format="n2"></e-column>
                                    <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                                    <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                                    <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                                    <e-column field='Reference' :columns='referenceColumns' textAlign="Center"></e-column>
                                    <e-column field='Variance to Reference' :columns='varianceColumns' textAlign="Center"></e-column>
                                    <e-column field='YoY' :columns='YoYColumns' textAlign="Center"></e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="additionalComponents">
            <div id="clientPositionSpinner"></div>
            <div id="target">
                <ejs-dialog id='dialog' ref="templateDialog" :isModal='true' :target='target' width="70%" height="90%" :showCloseIcon='true' :animationSettings='animationSettings' :visible="visible" :content="contentTemplate">
                </ejs-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Resize } from "@syncfusion/ej2-vue-grids";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';
    import gridOptions from '../../common/gridOptions'
    import { Query } from '@syncfusion/ej2-data';
    import store from '../../store';
    import router from '../../router/index';
    import { ToastPlugin, Toast } from "@syncfusion/ej2-vue-notifications";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { isNullOrUndefined } from '@syncfusion/ej2-base';
    import PdfComponent from '@/views/helperTemplates/PdfComponent.vue';
    import { Date } from "core-js";
    import SyncHelper from '../../common/syncfusion';

    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(GridPlugin);
    Vue.use(CheckBoxPlugin);

    export default {
        name: 'PositionSummaryReport',
        created() {
        },
        data() {
            return {
                wrapSettings: { wrapMode: 'Header' },
                data: {},
                target: '#target',
                unit: null,
                currency: null,
                currencyId: null,
                value: null,
                contentTemplate: function () {
                    return { template: PdfComponent }
                },
                timeUpdated: null,
                width: '250px',
                header: 'Dialog',
                visible: false,
                animationSettings: { effect: 'None' },
                electricityCalPosition: [],
                gasCalPosition: [],
                gasCalPositionAll: [],
                electricityCalPositionAll: [],
                gasCalPositionAll: [],
                isChecked: false,
                filterOptions: gridOptions.filterSettings,
                pageSettings: gridOptions.pageSettings,
                reportingView: [{ "name": "CAL", "id": 1 }, { "name": "FIY", "id": 2 }, { "name": "12M", "id": 3 }],
                periods: [{ "name": "Calendar", "id": "y" }, { "name": "Quarter", "id": "q" }, { "name": "Month", "id": "m" }],
                fixedColumns: [
                    {
                        field: 'fixedVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'fixedPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    }
                ],
                openColumns: [
                    {
                        field: 'openVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'openPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    }
                ],
                m2mColumns: [
                    {
                        field: 'm2mPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'm2mValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                referenceColumns: [
                    {
                        field: 'referencePrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'referenceValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                varianceColumns: [
                    {
                        field: 'variancePrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'varianceValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                YoYColumns: [
                    {
                        field: 'yoyDifferencePrice',
                        headerText: 'Difference Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    },
                    {
                        field: 'yoyDifferencePercentage',
                        headerText: 'Difference %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    }
                ],

            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('clientPositionSpinner'),

            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            showSpinner(document.getElementById('clientPositionSpinner'));
            showSpinner(document.getElementById('mainSpinner'));
            this.$refs.reportingView.ej2Instances.value = 1;
            this.$refs.dplPeriod.ej2Instances.value = "y";
            this.isChecked = this.getIsClientDefaultMFromLocalStorage(); 
            this.getPositionData("CAL");
        },
        methods: {
            downloadM2M: function (args) {
                showSpinner(document.getElementById('mainSpinner'));
                showSpinner(document.getElementById('clientPositionSpinner'));
                
                //this.currencyId = this.$refs.dplCurrency.value;
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateFullM2MReport/${store.state.reportClientId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}
                                   &defaultM=${store.state.isClientDefaultM == true ? true : false}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('clientPositionSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                },
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('clientPositionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                )

            },
            updateChecked(event) {
                // Update values in Local Storage-u
                this.setIsClientDefaultMInLocalStorage(event.checked);
                // Update values in Vuex store-u
                this.$store.commit('setClientCheckDefaultM', event.checked);
                let selected = document.getElementById('dplReportingView').value;
                this.getPositionData(selected);
            },
            onCurrencyChange: function (args) {

                this.currencyId = args.itemData.currencyId;
                let selected = document.getElementById('dplReportingView').value;
                this.getPositionData(selected, this.currencyId);
            },
            refreshData: function (args) {

                apis.protectedApi(`${urls.apiBaseUrl}Report/refreshClientData/${store.state.reportClientId}?defaultM=${store.state.isClientDefaultM == true ? true : false}`).then(it => {
                    //this.$refs.electricityGrid.refresh();
                    //this.$refs.gasGrid.refresh();
                    location.reload();
                });

                gridOptions.infoAlert("Refresh data triggered, the data is being processed now. The time will be refreshed in the next 2 min.");
            },
            download: function (args) {
                showSpinner(document.getElementById('mainSpinner'));
                showSpinner(document.getElementById('clientPositionSpinner'));
                this.currencyId = this.$refs.dplCurrency.value;
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateClientPositionReportPage/${store.state.reportClientId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&defaultM=${store.state.isClientDefaultM == true ? true : false}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('clientPositionSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                },

                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('clientPositionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            },
            getPositionData: function (reportView) {
                showSpinner(document.getElementById('mainSpinner'));
                showSpinner(document.getElementById('clientPositionSpinner'));
                apis.protectedApi(`report/clientpositionsummary/${store.state.reportClientId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&reportView=${reportView}&defaultM=${store.state.isClientDefaultM == true ? true : false}`)
                    .then(response => {
                        hideSpinner(document.getElementById('clientPositionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));

                        if (response && response.data && ((response.data.result.Electricity["y"] && response.data.result.Electricity["y"].length > 0) || (response.data.result.Gas["y"] && response.data.result.Gas["y"].length > 0))) {
                            this.electricityCalPositionAll = response.data.result.Electricity;
                            this.gasCalPositionAll = response.data.result.Gas;

                            var d = new Date(response.data.result.timeUpdated + "Z");
                            var datestring = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + " " +
                                d.getHours() + ":" + d.getMinutes();

                            if (response.data.result.timeUpdated != undefined) {
                                this.timeUpdated = datestring;
                            }
                            this.unit = response.data.unit;
                            
                            this.value = response.data.value;

                            this.currency = response.data.currency;
                            this.$refs.dplCurrency.ej2Instances.value = response.data.currencyId;
                            this.$refs.btnPositionSummary.ej2Instances.disabled = false;
                            this.$refs.btnM2mReport.ej2Instances.disabled = false;
                            this.updateDataSource();
                        }
                        else {
                            this.$refs.btnPositionSummary.ej2Instances.disabled = true;
                            this.$refs.btnM2mReport.ej2Instances.disabled = true;

                        }
                    }).catch(e => {
                        hideSpinner(document.getElementById('clientPositionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            dataBoundGas: function () {
                this.$refs.gasGrid.autoFitColumns();

            },
            dataBoundPower: function () {
                this.$refs.electricityGrid.autoFitColumns();

            },
            onReportViewSelect: function (args) {
                let selected = args.itemData.name;
                this.getPositionData(selected);
            },
            onPeriodChange: function (args) {

                this.updateDataSource();
            },
            updateDataSource: function () {
                this.electricityCalPosition = this.electricityCalPositionAll[this.$refs.dplPeriod.ej2Instances.value];
                this.gasCalPosition = this.gasCalPositionAll[this.$refs.dplPeriod.ej2Instances.value];

                if (this.$refs.dplPeriod.ej2Instances.value == "y") {

                    if (this.$refs.electricityGrid != undefined) {
                        this.$refs.electricityGrid.getColumns()[2].visible = true;//calendar
                        this.$refs.electricityGrid.getColumns()[1].visible = false;// name
                    }

                    if (this.$refs.gasGrid != undefined) {
                        this.$refs.gasGrid.getColumns()[2].visible = true;//calendar
                        this.$refs.gasGrid.getColumns()[1].visible = false;// name
                    }
                }
                else {

                    if (this.$refs.electricityGrid != undefined) {
                        this.$refs.electricityGrid.getColumns()[2].visible = false;//calendar
                        this.$refs.electricityGrid.getColumns()[1].visible = true;// name
                    }

                    if (this.$refs.gasGrid != undefined) {
                        this.$refs.gasGrid.getColumns()[2].visible = false;//calendar
                        this.$refs.gasGrid.getColumns()[1].visible = true;// name
                    }

                }
                if (this.$refs.electricityGrid != undefined) {
                    this.$refs.electricityGrid.refresh();
                }

                if (this.$refs.gasGrid != undefined) {
                    this.$refs.gasGrid.refresh();
                }


            },
            customiseCell: function (args) {
                if (args.column.field === 'totalContractedVolume' || args.column.field === 'openVolumeInContractTradingUnit') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.unit;
                } else if (args.column.field === 'fixedVolumePercentage' || args.column.field === 'openVolumePercentage' || args.column.field === "yoyDifferencePercentage") {
                    args.cell.textContent = args.cell.textContent + ' ' + "%";
                } else if (args.column.field === 'fixedPrice' || args.column.field === 'openPrice' || args.column.field === 'm2mPrice' || args.column.field === 'referencePrice' || args.column.field === 'variancePrice') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.value;
                } else if (args.column.field === 'referenceValue' || args.column.field === 'yoyDifferencePrice' || args.column.field === 'openValue' || args.column.field === 'm2mValue' || args.column.field === 'fixedValue' || args.column.field === 'varianceValue') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.currency;
                }
                if (args.data['countryName'] == 'TOTAL') {
                    args.cell.classList.add('greyTotal');
                }
            },
            getIsClientDefaultMFromLocalStorage() {
                const storedValue = localStorage.getItem('defaultMech');
                return storedValue ? JSON.parse(storedValue) : false;
            },
            setIsClientDefaultMInLocalStorage(value) {
                localStorage.setItem('defaultMech', JSON.stringify(value));
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);



            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
               
            },
        },
        computed: {
            currencies() {
                return SyncHelper.getDataManager("utils/currenciesAvailableClient?clientId=" + store.state.reportClientId);
            },
            volumeUnits() {
                return SyncHelper.getDataManager("utils/volumeUnits");
            },
        },
        watch: {
            '$store.state.isClientDefaultM'(newVal) {
                //Sync the local state with the store, ensuring real-time updates on value changes.
                this.isChecked = newVal;
            }
        },
        provide: {
            grid: [Resize]
        },

    }
</script>
<style>

    .greyTotal {
        background-color: lightgrey !important;
        font-weight: 500;
    }

    .e-primary-group {
        margin-left: 4px;
    }

    .df {
        display: flex;
    }

    #currency {
        margin-right: 5px !important;
    }

    .volume-unit {
        width: 100%;
        padding-left: 5px;
    }
    .postionCheck {
        margin: 25px 0px 0px 5px !important;
    }
    #clientPositionSpinner {
        display: none;
    }
</style>
<style scoped>
    .control-section {
        height: 100%;
        max-height: 380px;
        overflow: hidden;
    }
</style>
